// SPDX-License-Identifier: AGPL-3.0-or-later

// Shop items and bundles carry admin-written text: name and description in Turkish, and an optional English version
// that every other language shows. Display only: keys and set matching keep reading name.
// Before the catalogs load there is no locale yet: the English text, as for every language but Turkish.
function showsEnglish(locale: string | undefined): boolean {
	return !locale?.toLowerCase().startsWith('tr');
}

export function cosmeticName(item: {name: string; name_en?: string | null}, locale: string | undefined): string {
	return showsEnglish(locale) ? (item.name_en ?? item.name) : item.name;
}

export function cosmeticDescription(
	item: {description: string | null; description_en?: string | null},
	locale: string | undefined,
): string | null {
	return showsEnglish(locale) ? (item.description_en ?? item.description) : item.description;
}
